import React, { useEffect, useState } from 'react';
import { addNote, editNote } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddNoteModal = props => {
  const [note, setNote] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    subscriptionId,
    toggleModal,
    noteToEdit,
    onSuccess,
  } = props;
  const isEdit = !!noteToEdit;

  useEffect(() => {
    if (isEdit) setNote(noteToEdit.note);
  }, []);
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    let data: Record<string, any> = {
      id: subscriptionId,
      note,
    };
    if (isEdit) {
      data = {
        ...data,
        noteId: noteToEdit.id,
      };
    }
    try {
      if (isEdit) {
        await editNote(data);
      } else {
        await addNote(data);
      }
      showSuccess(`Note ${isEdit ? 'updated' : 'added'} successfully`);
      onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Subscription Note</div>
            <div className={styles['modal-title']}>{`${isEdit ? 'Edit' : 'Add'} Note`}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Note</div>
            <textarea
              className={'form-control'}
              value={note}
              onChange={e => setNote(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddNoteModal;